// extracted by mini-css-extract-plugin
module.exports = {"row":"AchievementRow_row__SfRsj","title":"AchievementRow_title__DByrO","badgesWrapper":"AchievementRow_badgesWrapper__0sZAZ","badge":"AchievementRow_badge__qMfIq"};